import { Dropdown as PrimeDropdown } from "primereact/dropdown";
import { classNames } from "primereact/utils";
import { forwardRef } from "react";

import { withDefaults } from "../../utils/with-defaults";
import { primeIcon } from "../icon";
import styles from "./dropdown.module.scss";
import { SELECT_FILTER_PLACEHOLDER } from "./messages";
import { withSelectPanelScrollBar } from "./with-select-panel-scroll-bar";
import type { DropdownProps } from "./types-dropdown";

/** Debounce padrão do filtro do Prime. */
const FILTER_DELAY_MS = 300;

/** Ícones do Figma no lugar dos do Prime: chevron-down 14 do gatilho, times-circle 14 do limpar, search 14 do filtro. */
const FIGMA_DEFAULTS = {
  dropdownIcon: primeIcon("chevron-down", 14),
  clearIcon: primeIcon("times-circle", 14),
  filterIcon: primeIcon("search", 14),
  filterPlaceholder: SELECT_FILTER_PLACEHOLDER,
  filterDelay: FILTER_DELAY_MS,
};

/** `Dropdown` do Prime com os ícones, as mensagens em pt-BR e o tamanho do Figma como padrão (a tela sobrescreve por prop). */
export const Dropdown = forwardRef<PrimeDropdown, DropdownProps>(function Dropdown(
  { id, inputId, size, className, ...props },
  ref,
) {
  return (
    <PrimeDropdown
      ref={ref}
      {...withDefaults({ ...FIGMA_DEFAULTS, appendTo: document.body }, props)}
      {...withSelectPanelScrollBar("dropdown", props)}
      inputId={inputId ?? id}
      className={classNames(
        styles.root,
        size === "sm" && "p-dropdown-sm",
        size === "lg" && "p-dropdown-lg",
        className,
      )}
    />
  );
});
Dropdown.displayName = "Dropdown";
